import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Re-uses the same minimal markdown renderer as the admin page
const renderMarkdown = (md) => {
  if (!md) return '';
  const escape = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  let html = escape(md);
  html = html.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');
  html = html.replace(/^# (.+)$/gm, '<h1>$1</h1>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/(^|\n)(- .+(\n- .+)*)/g, (match, prefix, block) => {
    const items = block.split('\n').map((l) => l.replace(/^- /, '').trim()).filter(Boolean);
    return `${prefix}<ul>${items.map((i) => `<li>${i}</li>`).join('')}</ul>`;
  });
  html = html.split(/\n{2,}/).map((para) => {
    if (/^<(h1|h2|h3|ul)/.test(para.trim())) return para;
    return `<p>${para.replace(/\n/g, '<br/>')}</p>`;
  }).join('\n');
  return html;
};

const VipTerms = () => {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    axios.get(`${API}/vip/terms`, { withCredentials: true })
      .then(({ data }) => setDoc(data))
      .catch(() => setDoc({ content: '', updated_at: null, version: 0 }));
  }, []);

  if (!doc) return <div className="text-[#A3A3A3]">Loading…</div>;

  return (
    <div data-testid="vip-terms-page" className="max-w-3xl">
      <div className="flex items-center gap-3 mb-2">
        <FileText className="w-7 h-7 text-[#D4AF37]" />
        <h2 className="font-['Outfit'] text-3xl font-bold text-white">VIP Terms &amp; Conditions</h2>
      </div>
      {doc.updated_at && (
        <p className="text-[#A3A3A3] text-xs flex items-center gap-2 mb-6">
          <Clock className="w-3 h-3" />
          Version {doc.version} · Last updated {new Date(doc.updated_at).toLocaleDateString()}
        </p>
      )}

      <div
        data-testid="vip-terms-content"
        className="bg-[#141414] border border-[#262626] rounded-md p-6 text-white text-sm leading-relaxed prose prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: renderMarkdown(doc.content) }}
      />
    </div>
  );
};

export default VipTerms;
